import { Injectable } from '@angular/core';
import { ReservationGiftStatus, ReservationGiftStatusDefinition } from 'app/models/reservation-gift-status.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { publishReplay, refCount } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { ListMetadata } from '../../models/list-metadata.model';


@Injectable()
export class ReservationGiftStatusService {

  giftStatus: ReservationGiftStatus[];
  giftStatusEdit: ReservationGiftStatus;

  giftStatusDefinition: ReservationGiftStatusDefinition[];

  private cachedFields: Observable<any>;

  private baseUrl = HttpClientService.BASE_MS_LOYALTY;

  constructor(
    private h: HttpClientService,
    private messageService: MessageService
  ) { }

  /**
   * Chiamata Get per ottenere la lista delle gift_status
   * @returns la lista delle gift status in un Array 
   */
  getAll(): Observable<ReservationGiftStatus[]> {
    return this.h.get(`${this.baseUrl}/reservation/gift_status`)
      .map(res => {
        return this.giftStatus = res;
      });
  }

  /**
   * Chiamata delete per eliminare un record, di cui passiamo l'id in Query param
   * @param record il record da eliminare
   * @returns un messaggio di avvenuta cancellazione
   */
  delete(record) {
    return this.h.delete(`${this.baseUrl}/reservation/gift_status/` + record.id)
      .map(res => {
        this.giftStatus.splice(this.giftStatus.indexOf(record), 1);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Gift Status deleted'});
      });
  }

  /**
   * Chiamata per creare una gift_status
   * @param newData i dati del record gift_status da creare
   * @returns un messaggio di operazione avvenuta con successo
   */
  post(newData) {
    return this.h.post(`${this.baseUrl}/reservation/gift_status`, newData)
      .map(res => {
        newData.id = res.id;
        this.giftStatus.push(newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  /**
   * Chiamata per modificare/aggiornare un record gift_status
   * @param newData i dati del record
   * @param id l'id del record
   * @returns un messaggio di operazione avvenuta con successo
   */
  put(newData, id) {
    return this.h.put(`${this.baseUrl}/reservation/gift_status/` + id, newData)
      .map(res => {
        Object.assign(this.giftStatusEdit, newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }
  
  /**
   * Fa una chiamata per caricare i campi del dto in memoria
   * @returns i campi caricati in memoria
   */
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get(this.baseUrl + '/schema/ReservationGiftStatusDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  /**
   * Chiamata per recuperare un record precedentemente cancellato, passando l'ide del record in Query param
   * @param record il record da recuperare
   * @returns un messaggio di operazione avvenuta con successo
   */
  recover(record){
    return this.h.put(`${this.baseUrl}/reservation/gift_status/recover/` + record.id, {})
      .map(res => {
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Gift Status recovered'});
      });
  }

  /**
   * Chiamata per ottenere una lista dei gift_status_definition
   * @returns la lista di gift_status_definition
   */
  getStatusDefiniiton(){
    return this.h.get(`${this.baseUrl}/reservation/get_status_definition`).map(res => {return this.giftStatusDefinition = res});
  }

  /**
   * Chiamata per ottenere una lista di gift_status_definition da passare al dropdown
   * @param offset 
   * @param limit 
   * @param search 
   * @param globalSearch 
   * @param sort 
   * @param sort_dir 
   * @returns la lista dei gift_status_definition
   */
  listDefinition(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<ReservationGiftStatusDefinition>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);

    return this.h.getPaged(this.baseUrl + '/reservation/get_status_definition');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/reservation-gift-status.service.ts